/**
 * WorkshopSection — the WORKSHOP block of the publish-shift drawer: loading/error/empty states plus the option list.
 *
 * Extracted from PublishShiftDrawer so each file declares one component
 * (`react/no-multi-comp`); behaviour is unchanged.
 */
import type { useRegionalWorkshops } from './regionalApi';
import { WorkshopOption } from './ShiftWorkshopOption';

export function WorkshopSection({
  workshops,
  workshopId,
  onSelect,
}: {
  workshops: ReturnType<typeof useRegionalWorkshops>;
  workshopId: string | null;
  onSelect: (id: string) => void;
}) {
  const upcoming = workshops.data ?? [];
  return (
    <section style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--nb-muted)' }}>WORKSHOP</div>
      {workshops.isLoading && (
        <div style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>Loading workshops…</div>
      )}
      {workshops.isError && (
        <div style={{ fontSize: 12, color: 'var(--nb-warn)' }}>
          Couldn’t load upcoming workshops.
        </div>
      )}
      {!workshops.isLoading && !workshops.isError && upcoming.length === 0 && (
        <div style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>
          No upcoming workshops in the next 6 weeks.
        </div>
      )}
      {upcoming.map((w) => (
        <WorkshopOption
          key={w.id}
          w={w}
          selected={w.id === workshopId}
          onSelect={() => onSelect(w.id)}
        />
      ))}
    </section>
  );
}
